import { useAtomValue } from 'jotai'
import React from 'react'

import {
  buildNineSegmentsBrandsData,
  type NineSegmentsBrandData,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import { useSampleSize } from '~/hooks/useSampleSize'

import { nineSegmentSortValueAtom, tabulationQueryDataAtom } from '../atoms'

export const useNineSegmentsBrandsData = (): NineSegmentsBrandData[] => {
  const sampleSize = useSampleSize()
  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)
  const sortValue = useAtomValue(nineSegmentSortValueAtom)

  return React.useMemo(
    () =>
      buildNineSegmentsBrandsData({
        brands9segs: tabulationQueryData?.result ?? [],
        sampleSize,
        sortValue,
      }),
    [sampleSize, sortValue, tabulationQueryData?.result],
  )
}
